import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4InputStartEventProps extends GA4GeneralProps {
  featureClass?: string | null
  featureName?: string | null
  inputMethod: string
}

export class GA4InputStartEvent extends GA4Event {
  ga4_feature_class: GA4InputStartEventProps['featureClass']
  ga4_feature_name: GA4InputStartEventProps['featureName']
  ga4_input_method: GA4InputStartEventProps['inputMethod']

  constructor({
    featureClass = null,
    featureName = null,
    inputMethod,
    ...generalProps
  }: GA4InputStartEventProps) {
    super({ event: EVENT.INPUT_START, ...generalProps })

    this.ga4_feature_class = featureClass
    this.ga4_feature_name = featureName
    this.ga4_input_method = inputMethod
  }
}
